"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LegacyFoundation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section className="bg-[hsl(65,30%,98%)] py-16 px-6">
      <div ref={ref} className={`
          max-w-[750px] mx-auto
          transition-all duration-700 ease-out-back
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
        `}>
        <p className="font-[var(--font-cinzel)] font-medium text-[22px] leading-[1.6] text-[hsl(210,100%,12%)] border-l-[3px] border-[hsl(45,65%,52%)] pl-8">
          Most people focus purely on the financial legacy—but without a{" "}
          <span className="text-[hsl(45,65%,52%)]">wisdom legacy</span>, family
          wealth lacks the foundation to endure.{" "}
          <span className="block mt-4">A <span className="text-[hsl(45,65%,52%)]" data-ast-id="f:/src/pages/Home/sections/LegacyFoundation.tsx|sig:8yd7ma" data-ast-start="918" data-ast-end="1098">lifetime of wisdom</span> is your family's most <span className="text-[hsl(45,65%,52%)]" data-ast-id="f:/src/pages/Home/sections/LegacyFoundation.tsx|sig:8yd7m9" data-ast-start="1121" data-ast-end="1298">valuable asset</span>.&nbsp;</span>
          <span className="block mt-4">
            I provide a{" "}
            <span className="text-[hsl(45,65%,52%)]">
              bespoke curation service
            </span>{" "}
            to capture your journey across{" "}
            <span className="text-[hsl(45,65%,52%)]">nine life pillars</span> {" "}
            and
            meticulously distill this into a signature{" "}
            <span className="text-[hsl(45,65%,52%)]">Heritage Compendium</span> and
            an{" "}
            <span className="text-[hsl(45,65%,52%)]">
              interactive Heritage Experience
            </span>
            , ensuring your{" "}
            <span className="text-[hsl(45,65%,52%)]">voice</span> remains a{" "}
            <span className="text-[hsl(45,65%,52%)]">guiding light</span> for
            every{" "}
            <span className="text-[hsl(45,65%,52%)]">generation</span> that
            follows.
          </span>
        </p>
      </div>
    </section>;
}